<template>
  <div>
    <div class="tf-block">
      <div class="tf-bg"></div>
      <LoadingSpinner v-if="cargando" />
      <div class="tf-card">
        <div class="tf-shell">
          <div class="tf-sec">
            <div class="tf-inner">
              <div class="tf-logo-wrap">
                <img
                  src="/img/logos/logo-sos.png"
                  alt="S.O.S Contingencias"
                  class="tf-logo"
                />
              </div>
              <h1 class="tf-title">Verificación en dos pasos</h1>
              <div
                v-if="mostrarSelectorCanal"
                class="tf-channels"
              >
                <button
                  v-if="canales.app"
                  type="button"
                  class="tf-channel"
                  :class="{ 'is-active': canal === 'app' }"
                  @click="seleccionarCanal('app')"
                >
                  App
                </button>
                <button
                  v-if="canales.email"
                  type="button"
                  class="tf-channel"
                  :class="{ 'is-active': canal === 'email' }"
                  @click="seleccionarCanal('email')"
                >
                  Correo
                </button>
                <button
                  type="button"
                  class="tf-channel"
                  :class="{ 'is-active': canal === 'recovery' }"
                  @click="seleccionarCanal('recovery')"
                >
                  Recuperación
                </button>
              </div>

              <form
                class="tf-form"
                @submit.prevent="verificar"
              >
                <div
                  v-if="canal === 'app'"
                  class="tf-field-group"
                >
                  <label
                    class="tf-label"
                    for="tf-code-app"
                    >Código de la app</label
                  >
                  <input
                    id="tf-code-app"
                    ref="inputCode"
                    :value="code"
                    type="text"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    maxlength="6"
                    class="tf-input"
                    placeholder="000000"
                    @input="onCodeInput"
                    @paste="onCodePaste"
                  />
                </div>

                <div
                  v-else-if="canal === 'email'"
                  class="tf-field-group"
                >
                  <label
                    class="tf-label"
                    for="tf-code-email"
                  >
                    Código enviado al correo
                  </label>
                  <input
                    id="tf-code-email"
                    ref="inputCode"
                    :value="code"
                    type="text"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    maxlength="6"
                    class="tf-input"
                    placeholder="000000"
                    @input="onCodeInput"
                    @paste="onCodePaste"
                  />
                  <button
                    type="button"
                    class="tf-link-btn"
                    :disabled="cargando || enviandoEmail"
                    @click="enviarCodigoCorreo"
                  >
                    {{
                      emailEnviado
                        ? "Reenviar código"
                        : "Enviar código al correo"
                    }}
                  </button>
                  <small
                    v-if="emailHint"
                    class="tf-hint"
                  >
                    Enviado a {{ emailHint }}
                  </small>
                </div>

                <div
                  v-else
                  class="tf-field-group"
                >
                  <label
                    class="tf-label"
                    for="tf-code-recovery"
                  >
                    Código de recuperación
                  </label>
                  <input
                    id="tf-code-recovery"
                    v-model.trim="recoveryCode"
                    type="text"
                    autocomplete="off"
                    class="tf-input tf-input--left"
                    placeholder="xxxx-xxxx"
                  />
                </div>

                <button
                  type="submit"
                  class="tf-submit"
                  :disabled="cargando || !puedeEnviar"
                >
                  <span
                    v-if="cargando"
                    class="spinner-border spinner-border-sm mr-1"
                    role="status"
                  ></span>
                  Verificar
                </button>

                <router-link
                  class="tf-back"
                  to="/LoginForm"
                >
                  Volver al inicio de sesión
                </router-link>
              </form>

              <div class="tf-footer">
                <img
                  src="/img/logos/Logo-Support-7-24.png"
                  alt="Support 7-24"
                  class="tf-footer-logo"
                />
              </div>
            </div>
          </div>

          <div class="tf-banner">
            <img
              class="tf-banner-img"
              src="/img/fondos/banerinicio3.png"
              alt="Support 7-24"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "../components/LoadingSpinner";

export default {
  name: "TwoFactorChallenge",
  components: { LoadingSpinner },
  data: () => ({
    code: "",
    recoveryCode: "",
    canal: "app",
    cargando: false,
    enviandoEmail: false,
    emailEnviado: false,
    emailHint: "",
  }),
  computed: {
    canales() {
      return (
        this.$store.getters.pendingTwoFactorChannels || {
          app: false,
          email: false,
        }
      );
    },
    mostrarSelectorCanal() {
      return Boolean(this.canales.app || this.canales.email);
    },
    puedeEnviar() {
      if (this.canal === "recovery") {
        return String(this.recoveryCode || "").trim().length >= 8;
      }
      if (this.canal === "email" && !this.emailEnviado) {
        return false;
      }
      return /^\d{6}$/.test(String(this.code || "").trim());
    },
  },
  mounted() {
    if (!this.$store.getters.pendingTwoFactor) {
      this.$router.replace({ name: "LoginForm" });
      return;
    }
    if (this.canales.app) this.canal = "app";
    else if (this.canales.email) this.canal = "email";
    else this.canal = "recovery";

    this.$nextTick(() => {
      if (this.$refs.inputCode) this.$refs.inputCode.focus();
      if (this.canal === "email") {
        this.enviarCodigoCorreo();
      }
    });
  },
  methods: {
    normalizarCodigo(valor) {
      return String(valor || "")
        .replace(/\D+/g, "")
        .slice(0, 6);
    },
    onCodeInput(e) {
      this.code = this.normalizarCodigo(e && e.target ? e.target.value : "");
    },
    onCodePaste(e) {
      e.preventDefault();
      const raw =
        (e.clipboardData && e.clipboardData.getData("text")) ||
        (window.clipboardData && window.clipboardData.getData("Text")) ||
        "";
      this.code = this.normalizarCodigo(raw);
    },
    seleccionarCanal(canal) {
      this.canal = canal;
      this.code = "";
      this.recoveryCode = "";
      this.$nextTick(() => {
        if (this.$refs.inputCode) this.$refs.inputCode.focus();
      });
      if (canal === "email" && !this.emailEnviado) {
        this.enviarCodigoCorreo();
      }
    },
    mostrarError(text) {
      this.$swal({ icon: "error", title: "Oops...", text });
    },
    async enviarCodigoCorreo() {
      if (this.enviandoEmail) return;
      this.enviandoEmail = true;
      try {
        const data = await this.$store.dispatch("sendTwoFactorEmail");
        this.emailEnviado = true;
        this.emailHint = (data && data.email_hint) || "";
        this.$swal({
          icon: "success",
          title: "Código enviado",
          text: (data && data.message) || "Revise su correo.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } catch (e) {
        const msg =
          this.$store.getters.getMensajeLogin ||
          "No fue posible enviar el código al correo.";
        this.mostrarError(msg);
      } finally {
        this.enviandoEmail = false;
      }
    },
    async verificar() {
      if (this.cargando || !this.puedeEnviar) return;
      this.cargando = true;
      try {
        let ok = false;
        if (this.canal === "email") {
          ok = await this.$store.dispatch("verifyTwoFactorEmail", {
            code: this.code,
          });
        } else if (this.canal === "recovery") {
          ok = await this.$store.dispatch("verifyTwoFactor", {
            recovery_code: this.recoveryCode,
          });
        } else {
          ok = await this.$store.dispatch("verifyTwoFactor", {
            code: this.code,
          });
        }
        if (ok) {
          if (this.$store.getters.requiresTwoFactorSetup) {
            return this.$router.replace({ name: "PerfilUsuario" });
          }
          return this.$router.replace("/");
        }
        const msg =
          this.$store.getters.getMensajeLogin ||
          "No fue posible verificar el código.";
        this.mostrarError(msg);
      } finally {
        this.cargando = false;
      }
    },
  },
};
</script>

<style scoped>
.tf-block {
  width: 100%;
  min-height: 100vh;
  padding: 28px 16px;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  background: linear-gradient(to bottom right, #153f75, #bad35c);
  background-size: 250% 250%;
  animation: tfGradient 7s ease infinite;
}

.tf-bg {
  position: absolute;
  inset: 0;
  background-image: url("../../public/img/fondos/fondo_sos_contingencias.png");
  background-size: cover;
  opacity: 0.3;
  pointer-events: none;
}

@keyframes tfGradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.tf-card {
  position: relative;
  z-index: 1;
  width: min(980px, 94vw);
  max-width: 980px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 18px 12px 0 rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.tf-shell {
  display: grid;
  grid-template-columns: 34% 66%;
  height: 460px;
  min-height: 460px;
  align-items: stretch;
}

.tf-sec {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: #fff;
  padding: 0.85rem 1.15rem 1rem;
  box-sizing: border-box;
  height: 100%;
  overflow: auto;
}

.tf-inner {
  width: 100%;
  max-width: 250px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  min-height: 100%;
}

.tf-logo-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: -0.35rem 0 0.45rem;
}

.tf-logo {
  display: block;
  width: 148px;
  max-width: 100%;
  height: auto;
}

.tf-title {
  margin: 0 0 0.35rem;
  width: 100%;
  font-size: 0.98rem;
  font-weight: 700;
  color: #153f75;
  line-height: 1.25;
}

.tf-channels {
  display: flex;
  width: 100%;
  gap: 0.35rem;
  margin: 0 0 0.75rem;
}

.tf-channel {
  flex: 1 1 0;
  min-width: 0;
  border: 1px solid #d5dbe3;
  background: #f4f6f8;
  color: #4b5563;
  border-radius: 8px;
  padding: 0.4rem 0.25rem;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
}

.tf-channel.is-active {
  background: #153f75;
  border-color: #153f75;
  color: #fff;
}

.tf-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.tf-field-group {
  width: 100%;
  margin: 0 0 0.7rem;
  text-align: left;
}

.tf-label {
  display: block;
  margin: 0 0 0.3rem;
  font-size: 0.74rem;
  font-weight: 600;
  color: #475569;
}

.tf-input {
  display: block;
  width: 100%;
  box-sizing: border-box;
  height: 40px;
  border: 1px solid transparent;
  border-radius: 999px;
  background: #f2f2f2;
  padding: 0 0.9rem;
  font-size: 0.95rem;
  letter-spacing: 0.12em;
  text-align: center;
  color: #2b2f36;
  outline: none;
}

.tf-input:focus {
  border-color: #153f75;
  background: #fff;
}

.tf-input--left {
  letter-spacing: normal;
  text-align: left;
}

.tf-link-btn {
  display: inline-block;
  margin-top: 0.35rem;
  border: 0;
  background: transparent;
  color: #153f75;
  font-size: 0.74rem;
  font-weight: 600;
  padding: 0;
  cursor: pointer;
  text-align: left;
}

.tf-link-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.tf-hint {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.7rem;
  color: #6b7280;
}

.tf-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 40px;
  margin: 0.15rem 0 0.7rem;
  border: 0;
  border-radius: 10px;
  background: #153f75;
  color: #ffffff !important;
  font-weight: 700;
  font-size: 0.8rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
}

.tf-submit:disabled {
  background: #9fa3a9;
  color: #ffffff !important;
  cursor: not-allowed;
}

.tf-back {
  display: block;
  text-align: center;
  font-size: 0.76rem;
  font-weight: 600;
  color: #153f75;
  text-decoration: none;
}

.tf-back:hover {
  text-decoration: underline;
  color: #0f2f58;
}

.tf-footer {
  margin-top: auto;
  padding-top: 0.9rem;
  width: 100%;
  display: flex;
  justify-content: center;
}

.tf-footer-logo {
  display: block;
  width: 120px;
  max-width: 100%;
  height: auto;
}

.tf-banner {
  position: relative;
  height: 100%;
  overflow: hidden;
  background: #111;
}

.tf-banner-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 767.98px) {
  .tf-block {
    padding: 16px 12px;
    position: relative;
    height: auto;
  }

  .tf-card {
    width: 100%;
    max-width: 420px;
    box-shadow: 10px 10px 0 rgba(0, 0, 0, 0.1);
  }

  .tf-shell {
    grid-template-columns: 1fr;
    height: auto;
    min-height: 0;
  }

  .tf-sec {
    height: auto;
    padding: 1rem 1.15rem 1.15rem;
  }

  .tf-banner {
    height: 180px;
  }

  .tf-banner-img {
    height: 180px;
  }
}
</style>
